import type { SvgIconProps } from '@mui/material';
import { SvgIcon } from '@mui/material';
import { memo } from 'react';

/**
 * Animated SVG icon of an envelope.
 *
 * Converted to a React and Mui Component from icon_nl_subscribe_3_successful.svg,
 * but adjusted to fix some positioning and sizing issues.
 *
 * You can pass SX props.
 */
const SvgIconNlSubscribe3Successful = (props: SvgIconProps) => {
  const { sx, ...other } = props;
  return (
    <SvgIcon
      id="icon_nl_subscribe_3_successful_svg__newsletter_icon_ani_layers_checkmark"
      xmlns="http://www.w3.org/2000/svg"
      xmlnsXlink="http://www.w3.org/1999/xlink"
      viewBox="200 200 200 300"
      shapeRendering="geometricPrecision"
      textRendering="geometricPrecision"
      sx={{
        ...sx,
      }}
      {...other}
    >
      <style>
        {
          '@keyframes newsletter_icon_ani_layers_checkmark-g1_ts__ts{0%,4.444444%,88.888889%,to{transform:translate(298.0865px,377.936px) scale(1,0)}8.888889%,84.444444%{transform:translate(298.0865px,377.936px) scale(1,1);animation-timing-function:cubic-bezier(.42,0,1,1)}}@keyframes newsletter_icon_ani_layers_checkmark-g1_c_o{0%,6.666667%,86.666667%,to{opacity:0}8.888889%,84.444444%{opacity:1}}@keyframes newsletter_icon_ani_layers_checkmark-briefpapier_x5f_innenteil_to__to{0%,8.888889%,80%,to{transform:translate(297.936508px,421.629517px)}15.555556%,75.555556%{transform:translate(297.936508px,334.629517px)}}@keyframes newsletter_icon_ani_layers_checkmark-klappe_x5f_seperat_ts__ts{0%,88.888889%,to{transform:translate(298.0865px,358.737px) scale(1,1)}4.444444%{transform:translate(298.0865px,358.737px) scale(1,1);animation-timing-function:cubic-bezier(.42,0,1,1)}8.888889%,84.444444%{transform:translate(298.0865px,358.737px) scale(1,0)}}@keyframes newsletter_icon_ani_layers_checkmark-circle1_ts__ts{0%,22.222222%,64.444444%,to{transform:translate(297.640015px,383.441986px) rotate(3615deg) scale(0,0)}26.666667%{transform:translate(297.640015px,383.441986px) rotate(3615deg) scale(1.2,1.2)}28.888889%,60%{transform:translate(297.640015px,383.441986px) rotate(3615deg) scale(1,1)}}@keyframes newsletter_icon_ani_layers_checkmark-g7_ts__ts{0%,24.444444%,62.222222%,to{transform:translate(297.044495px,355.985001px) scale(0,0)}26.666667%,60%{transform:translate(297.044495px,355.985001px) scale(1,1)}}@keyframes newsletter_icon_ani_layers_checkmark-line4_ts__ts{0%,68.888889%,to{transform:translate(235.034px,300.525px) scale(0,1)}15.555556%{transform:translate(235.034px,300.525px) scale(0,1);animation-timing-function:cubic-bezier(.42,0,1,1)}20%,64.444444%{transform:translate(235.034px,300.525px) scale(1,1);animation-timing-function:cubic-bezier(.42,0,1,1)}}@keyframes newsletter_icon_ani_layers_checkmark-line5_ts__ts{0%,71.111111%,to{transform:translate(235.034px,322.7px) scale(0,1)}17.777778%{transform:translate(235.034px,322.7px) scale(0,1);animation-timing-function:cubic-bezier(.42,0,1,1)}22.222222%,66.666667%{transform:translate(235.034px,322.7px) scale(1,1);animation-timing-function:cubic-bezier(.42,0,1,1)}}@keyframes newsletter_icon_ani_layers_checkmark-line6_ts__ts{0%,73.333333%,to{transform:translate(235.034px,342.684375px) scale(0,1)}20%{transform:translate(235.034px,342.684375px) scale(0,1);animation-timing-function:cubic-bezier(.42,0,1,1)}24.444444%,68.888889%{transform:translate(235.034px,342.684375px) scale(1,1);animation-timing-function:cubic-bezier(.42,0,1,1)}}'
        }
      </style>
      <defs>
        <path
          id="icon_nl_subscribe_3_successful_svg__newsletter_icon_ani_layers_checkmark-svgid_2_"
          d="M285.288 383.442a.719.719 0 0 0-1.042 0l-2.827 2.828a.719.719 0 0 0 0 1.042l9.227 9.376a.719.719 0 0 0 1.042 0l22.024-20.984a.719.719 0 0 0 0-1.042l-2.679-2.828a.718.718 0 0 0-1.041 0l-18.752 17.561-5.952-5.953Z"
        />
        <path
          id="icon_nl_subscribe_3_successful_svg__newsletter_icon_ani_layers_checkmark-svgid_7_"
          d="M285.288 383.442a.719.719 0 0 0-1.042 0l-2.827 2.828a.719.719 0 0 0 0 1.042l9.227 9.376a.719.719 0 0 0 1.042 0l22.024-20.984a.719.719 0 0 0 0-1.042l-2.679-2.828a.718.718 0 0 0-1.041 0l-18.752 17.561-5.952-5.953Z"
        />
        <path
          id="icon_nl_subscribe_3_successful_svg__newsletter_icon_ani_layers_checkmark-svgid_9_"
          d="M285.288 383.442a.719.719 0 0 0-1.042 0l-2.827 2.828a.719.719 0 0 0 0 1.042l9.227 9.376a.719.719 0 0 0 1.042 0l22.024-20.984a.719.719 0 0 0 0-1.042l-2.679-2.828a.718.718 0 0 0-1.041 0l-18.752 17.561-5.952-5.953Z"
        />
        <path
          id="icon_nl_subscribe_3_successful_svg__newsletter_icon_ani_layers_checkmark-svgid_11_"
          d="M285.288 383.442a.719.719 0 0 0-1.042 0l-2.827 2.828a.719.719 0 0 0 0 1.042l9.227 9.376a.719.719 0 0 0 1.042 0l22.024-20.984a.719.719 0 0 0 0-1.042l-2.679-2.828a.718.718 0 0 0-1.041 0l-18.752 17.561-5.952-5.953Z"
        />
        <rect
          id="icon_nl_subscribe_3_successful_svg__newsletter_icon_ani_layers_checkmark-svgid_5_"
          width={47.622}
          height={47.622}
          rx={0}
          ry={0}
        />
      </defs>
      <g
        transform="translate(297.937 421.63)"
        style={{
          animation:
            'newsletter_icon_ani_layers_checkmark-briefpapier_x5f_innenteil_to__to 4500ms linear 3 normal forwards',
        }}
      >
        <g
          id="icon_nl_subscribe_3_successful_svg__newsletter_icon_ani_layers_checkmark-briefpapier_x5f_innenteil"
          transform="translate(-297.937 -334.63)"
        >
          <path
            id="icon_nl_subscribe_3_successful_svg__newsletter_icon_ani_layers_checkmark-polyline1"
            fill="#FFF"
            stroke="none"
            strokeWidth={1}
            d="M219.361 387.014v-104.62h157.154v104.62"
          />
          <g id="icon_nl_subscribe_3_successful_svg__newsletter_icon_ani_layers_checkmark-g2">
            <path
              id="icon_nl_subscribe_3_successful_svg__newsletter_icon_ani_layers_checkmark-path2"
              d="M376.515 390.586a3.685 3.685 0 0 1-3.721-3.721V286.114H223.081v100.751a3.685 3.685 0 0 1-3.721 3.721 3.685 3.685 0 0 1-3.721-3.721V282.394a3.686 3.686 0 0 1 3.721-3.721h157.154a3.684 3.684 0 0 1 3.72 3.721v104.472a3.683 3.683 0 0 1-3.719 3.72Z"
              fill="#000"
              stroke="none"
              strokeWidth={1}
            />
          </g>
        </g>
      </g>
      <g id="icon_nl_subscribe_3_successful_svg__newsletter_icon_ani_layers_checkmark-vorderteil_x5f_oeffnung">
        <path
          id="icon_nl_subscribe_3_successful_svg__newsletter_icon_ani_layers_checkmark-path3"
          d="M204.33 376.448v99.859c0 8.333 6.696 15.03 15.03 15.03h157.154c8.334 0 15.03-6.697 15.03-15.03V375.258l-80.81 48.515c-7.143 4.316-18.602 4.316-25.597 0l-80.809-48.515"
          fill="#FFF"
          stroke="none"
          strokeWidth={1}
        />
        <path
          id="icon_nl_subscribe_3_successful_svg__newsletter_icon_ani_layers_checkmark-path4"
          d="M391.545 360.227a3.685 3.685 0 0 0-3.721 3.72v9.078L308.95 420.35c-5.953 3.572-15.924 3.572-21.728 0l-78.875-47.325v-9.078a3.684 3.684 0 0 0-3.721-3.72 3.684 3.684 0 0 0-3.72 3.72v112.21c0 10.269 8.334 18.751 18.751 18.751h156.856c10.269 0 18.751-8.333 18.751-18.751v-112.21a3.68 3.68 0 0 0-3.719-3.72Zm-15.03 127.241H219.361c-6.25 0-11.311-5.06-11.311-11.162v-94.5l62.803 37.652-50.45 50.45a3.772 3.772 0 0 0 0 5.357c.744.744 1.637 1.041 2.679 1.041 1.042 0 1.935-.297 2.679-1.041l51.789-51.79 5.805 3.423c4.167 2.53 9.375 3.721 14.732 3.721 5.358 0 10.566-1.19 14.733-3.721l5.804-3.423 51.79 51.79c.743.744 1.637 1.041 2.679 1.041 1.041 0 1.935-.297 2.679-1.041a3.772 3.772 0 0 0 0-5.357l-50.748-50.45 62.802-37.652v94.5c-.15 6.102-5.061 11.162-11.311 11.162Z"
          fill="#000"
          stroke="none"
          strokeWidth={1}
        />
      </g>
      <g
        transform="translate(298.087 358.737)"
        style={{
          animation:
            'newsletter_icon_ani_layers_checkmark-klappe_x5f_seperat_ts__ts 4500ms linear 3 normal forwards',
        }}
      >
        <g
          id="icon_nl_subscribe_3_successful_svg__newsletter_icon_ani_layers_checkmark-klappe_x5f_seperat"
          transform="translate(-298.087 -358.737)"
        >
          <g id="icon_nl_subscribe_3_successful_svg__newsletter_icon_ani_layers_checkmark-g3">
            <path
              id="icon_nl_subscribe_3_successful_svg__newsletter_icon_ani_layers_checkmark-path5"
              d="m391.695 375.704-80.81 48.515c-7.144 4.316-18.603 4.316-25.597 0l-80.81-48.515v-13.096h186.918l.299 13.096Z"
              fill="#FFF"
              stroke="none"
              strokeWidth={1}
            />
          </g>
          <g id="icon_nl_subscribe_3_successful_svg__newsletter_icon_ani_layers_checkmark-g4">
            <g id="icon_nl_subscribe_3_successful_svg__newsletter_icon_ani_layers_checkmark-g5">
              <path
                id="icon_nl_subscribe_3_successful_svg__newsletter_icon_ani_layers_checkmark-path6"
                d="M298.086 431.064c-5.357 0-10.565-1.19-14.732-3.72l-80.81-48.516c-1.19-.744-1.786-1.935-1.786-3.274v-13.096a3.686 3.686 0 0 1 3.721-3.721h186.918a3.685 3.685 0 0 1 3.721 3.721l.148 13.096c0 1.339-.744 2.53-1.786 3.274l-80.809 48.516c-4.018 2.382-9.227 3.72-14.585 3.72Zm-89.887-57.592 78.874 47.324c5.953 3.572 15.924 3.572 21.728 0l78.875-47.324-.148-7.292H208.199v7.292Z"
                fill="#000"
                stroke="none"
                strokeWidth={1}
              />
            </g>
          </g>
        </g>
      </g>
      <g
        transform="matrix(0 0 0 0 297.64 383.442)"
        style={{
          animation:
            'newsletter_icon_ani_layers_checkmark-circle1_ts__ts 4500ms linear 3 normal forwards',
        }}
      >
        <circle
          id="icon_nl_subscribe_3_successful_svg__newsletter_icon_ani_layers_checkmark-circle1"
          r={28.276}
          fill="#7DAE2E"
          stroke="none"
          strokeWidth={1}
        />
      </g>
      <g
        transform="matrix(0 0 0 0 297.044 355.985)"
        style={{
          animation:
            'newsletter_icon_ani_layers_checkmark-g7_ts__ts 4500ms linear 3 normal forwards',
        }}
      >
        <g
          id="icon_nl_subscribe_3_successful_svg__newsletter_icon_ani_layers_checkmark-g7"
          transform="translate(-297.044 -355.985)"
        >
          <g
            id="icon_nl_subscribe_3_successful_svg__newsletter_icon_ani_layers_checkmark-g8"
            clipPath="url(#icon_nl_subscribe_3_successful_svg__newsletter_icon_ani_layers_checkmark-svgid_4_)"
          >
            <g id="icon_nl_subscribe_3_successful_svg__newsletter_icon_ani_layers_checkmark-g9">
              <g id="icon_nl_subscribe_3_successful_svg__newsletter_icon_ani_layers_checkmark-g10">
                <rect
                  id="icon_nl_subscribe_3_successful_svg__newsletter_icon_ani_layers_checkmark-svgid_3_"
                  width={47.622}
                  height={47.622}
                  rx={0}
                  ry={0}
                  transform="translate(273.829 359.78)"
                  fill="#FFF"
                  stroke="none"
                  strokeWidth={1}
                />
              </g>
              <g id="icon_nl_subscribe_3_successful_svg__newsletter_icon_ani_layers_checkmark-g11">
                <g id="icon_nl_subscribe_3_successful_svg__newsletter_icon_ani_layers_checkmark-g12">
                  <g
                    id="icon_nl_subscribe_3_successful_svg__newsletter_icon_ani_layers_checkmark-g13"
                    clipPath="url(#icon_nl_subscribe_3_successful_svg__newsletter_icon_ani_layers_checkmark-svgid_6_)"
                  >
                    <rect
                      id="icon_nl_subscribe_3_successful_svg__newsletter_icon_ani_layers_checkmark-rect1"
                      width={47.622}
                      height={40.181}
                      rx={0}
                      ry={0}
                      transform="translate(273.829 364.245)"
                      fill="#FFF"
                      stroke="none"
                      strokeWidth={1}
                    />
                    <clipPath id="icon_nl_subscribe_3_successful_svg__newsletter_icon_ani_layers_checkmark-svgid_6_">
                      <use
                        id="icon_nl_subscribe_3_successful_svg__newsletter_icon_ani_layers_checkmark-use1"
                        width={47.622}
                        height={47.622}
                        xlinkHref="#icon_nl_subscribe_3_successful_svg__newsletter_icon_ani_layers_checkmark-svgid_5_"
                        transform="translate(273.829 359.78)"
                        fill="#000"
                        stroke="none"
                        strokeWidth={1}
                      />
                    </clipPath>
                  </g>
                </g>
              </g>
              <g id="icon_nl_subscribe_3_successful_svg__newsletter_icon_ani_layers_checkmark-g14">
                <g
                  id="icon_nl_subscribe_3_successful_svg__newsletter_icon_ani_layers_checkmark-g15"
                  clipPath="url(#icon_nl_subscribe_3_successful_svg__newsletter_icon_ani_layers_checkmark-svgid_8_)"
                >
                  <g id="icon_nl_subscribe_3_successful_svg__newsletter_icon_ani_layers_checkmark-schatten_x5f_stroke_kopie_1_">
                    <path
                      id="icon_nl_subscribe_3_successful_svg__newsletter_icon_ani_layers_checkmark-line1"
                      fill="none"
                      stroke="#000"
                      strokeWidth={4.5}
                      strokeLinecap="round"
                      strokeLinejoin="round"
                      strokeMiterlimit={10}
                      d="M238.707 304.568h53.278"
                    />
                  </g>
                  <clipPath id="icon_nl_subscribe_3_successful_svg__newsletter_icon_ani_layers_checkmark-svgid_8_">
                    <use
                      id="icon_nl_subscribe_3_successful_svg__newsletter_icon_ani_layers_checkmark-use2"
                      width={32.74}
                      height={25.301}
                      xlinkHref="#icon_nl_subscribe_3_successful_svg__newsletter_icon_ani_layers_checkmark-svgid_7_"
                      fill="#000"
                      stroke="none"
                      strokeWidth={1}
                    />
                  </clipPath>
                </g>
              </g>
              <g id="icon_nl_subscribe_3_successful_svg__newsletter_icon_ani_layers_checkmark-g16">
                <g
                  id="icon_nl_subscribe_3_successful_svg__newsletter_icon_ani_layers_checkmark-g17"
                  clipPath="url(#icon_nl_subscribe_3_successful_svg__newsletter_icon_ani_layers_checkmark-svgid_10_)"
                >
                  <g id="icon_nl_subscribe_3_successful_svg__newsletter_icon_ani_layers_checkmark-schatten_x5f_stroke_kopie_2_">
                    <path
                      id="icon_nl_subscribe_3_successful_svg__newsletter_icon_ani_layers_checkmark-line2"
                      fill="none"
                      stroke="#000"
                      strokeWidth={4.5}
                      strokeLinecap="round"
                      strokeLinejoin="round"
                      strokeMiterlimit={10}
                      d="M238.707 322.277h116.675"
                    />
                  </g>
                  <clipPath id="icon_nl_subscribe_3_successful_svg__newsletter_icon_ani_layers_checkmark-svgid_10_">
                    <use
                      id="icon_nl_subscribe_3_successful_svg__newsletter_icon_ani_layers_checkmark-use3"
                      width={32.74}
                      height={25.301}
                      xlinkHref="#icon_nl_subscribe_3_successful_svg__newsletter_icon_ani_layers_checkmark-svgid_9_"
                      fill="#000"
                      stroke="none"
                      strokeWidth={1}
                    />
                  </clipPath>
                </g>
              </g>
              <g id="icon_nl_subscribe_3_successful_svg__newsletter_icon_ani_layers_checkmark-g18">
                <g
                  id="icon_nl_subscribe_3_successful_svg__newsletter_icon_ani_layers_checkmark-g19"
                  clipPath="url(#icon_nl_subscribe_3_successful_svg__newsletter_icon_ani_layers_checkmark-svgid_12_)"
                >
                  <g id="icon_nl_subscribe_3_successful_svg__newsletter_icon_ani_layers_checkmark-schatten_x5f_stroke_kopie_3_">
                    <path
                      id="icon_nl_subscribe_3_successful_svg__newsletter_icon_ani_layers_checkmark-line3"
                      fill="none"
                      stroke="#000"
                      strokeWidth={4.5}
                      strokeLinecap="round"
                      strokeLinejoin="round"
                      strokeMiterlimit={10}
                      d="M238.707 337.606h116.675"
                    />
                  </g>
                  <clipPath id="icon_nl_subscribe_3_successful_svg__newsletter_icon_ani_layers_checkmark-svgid_12_">
                    <use
                      id="icon_nl_subscribe_3_successful_svg__newsletter_icon_ani_layers_checkmark-use4"
                      width={32.74}
                      height={25.301}
                      xlinkHref="#icon_nl_subscribe_3_successful_svg__newsletter_icon_ani_layers_checkmark-svgid_11_"
                      fill="#000"
                      stroke="none"
                      strokeWidth={1}
                    />
                  </clipPath>
                </g>
              </g>
            </g>
            <clipPath id="icon_nl_subscribe_3_successful_svg__newsletter_icon_ani_layers_checkmark-svgid_4_">
              <use
                id="icon_nl_subscribe_3_successful_svg__newsletter_icon_ani_layers_checkmark-use5"
                width={32.74}
                height={25.301}
                xlinkHref="#icon_nl_subscribe_3_successful_svg__newsletter_icon_ani_layers_checkmark-svgid_2_"
                fill="#000"
                stroke="none"
                strokeWidth={1}
              />
            </clipPath>
          </g>
        </g>
      </g>
      <g
        transform="matrix(0 0 0 1 235.034 300.525)"
        style={{
          animation:
            'newsletter_icon_ani_layers_checkmark-line4_ts__ts 4500ms linear 3 normal forwards',
        }}
      >
        <path
          id="icon_nl_subscribe_3_successful_svg__newsletter_icon_ani_layers_checkmark-line4"
          fill="none"
          stroke="#000"
          strokeWidth={4.5}
          strokeLinecap="round"
          strokeLinejoin="round"
          strokeMiterlimit={10}
          d="M0 0h54.32"
        />
      </g>
      <g
        transform="matrix(0 0 0 1 235.034 322.7)"
        style={{
          animation:
            'newsletter_icon_ani_layers_checkmark-line5_ts__ts 4500ms linear 3 normal forwards',
        }}
      >
        <path
          id="icon_nl_subscribe_3_successful_svg__newsletter_icon_ani_layers_checkmark-line5"
          fill="none"
          stroke="#000"
          strokeWidth={4.5}
          strokeLinecap="round"
          strokeLinejoin="round"
          strokeMiterlimit={10}
          d="M0 0h126.05"
        />
      </g>
      <g
        transform="matrix(0 0 0 1 235.034 342.684)"
        style={{
          animation:
            'newsletter_icon_ani_layers_checkmark-line6_ts__ts 4500ms linear 3 normal forwards',
        }}
      >
        <path
          id="icon_nl_subscribe_3_successful_svg__newsletter_icon_ani_layers_checkmark-line6"
          fill="none"
          stroke="#000"
          strokeWidth={4.5}
          strokeLinecap="round"
          strokeLinejoin="round"
          strokeMiterlimit={10}
          d="M0-2.125h126.05"
        />
      </g>
    </SvgIcon>
  );
};
const Memo = memo(SvgIconNlSubscribe3Successful);
// eslint-disable-next-line import/no-default-export
export default Memo;
